<template>
  <div class="number-range-question">
    <div class="question-txt">{{question.questionText}}</div>
    <div class="slider">
      <div class="slider-box">
      <vue-slider :min=question.lowerBoundary
                  :max=question.upperBoundary
                  :tooltip="'always'"
                  v-model="answer_"
      ></vue-slider>
        </div>
      <div class="lower-boundary">{{question.lowerBoundary}}</div>
      <div class="upper-boundary">{{question.upperBoundary}}</div>
      <div class="lower-boundary-txt">{{question.lowerBoundaryText}}</div>
      <div class="upper-boundary-txt">{{question.upperBoundaryText}}</div>
    </div>
  </div>
</template>

<script>
import syncProperty from '../../../../mixins/syncProperty'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

export default {
  name: 'FeedbackQuestionNumberRange',
  components: {
    VueSlider
  },
  mixins: [
    syncProperty('answer', 'answer_')
  ],
  props: {
    question: {
      type: Object
    }
  }
}
</script>
